var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Icons } from 'src/ui/components/Icons/Icons';
import { COLORS } from 'src/shared/styles/colors';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import './snackbar.scss';
import { IDENTIFIER_SNACKBAR_ITEM, IDENTIFIER_SNACKBAR_LIST } from 'src/ui/components/SnackBar/constants';
export var E_SNACKBAR_TYPE;
(function (E_SNACKBAR_TYPE) {
    E_SNACKBAR_TYPE[E_SNACKBAR_TYPE["VALID"] = 0] = "VALID";
    E_SNACKBAR_TYPE[E_SNACKBAR_TYPE["INFO"] = 1] = "INFO";
    E_SNACKBAR_TYPE[E_SNACKBAR_TYPE["ERROR"] = 2] = "ERROR";
})(E_SNACKBAR_TYPE || (E_SNACKBAR_TYPE = {}));
var NOTIFICATION_TIME_BEFORE_DISAPPEAR = 5000;
var FRAME_BY_SECOND = 60;
var getColorsNotification = function (type) {
    switch (type) {
        case E_SNACKBAR_TYPE.VALID:
            return {
                color: COLORS.WHITE,
                backgroundColor: COLORS.GREEN['500'],
                delayBar: COLORS.GREEN['300'],
            };
        case E_SNACKBAR_TYPE.INFO:
            return {
                color: COLORS.WHITE,
                backgroundColor: COLORS.BLUE['500'],
                delayBar: COLORS.BLUE['300'],
            };
        case E_SNACKBAR_TYPE.ERROR:
            return {
                color: COLORS.WHITE,
                backgroundColor: COLORS.RED['500'],
                delayBar: COLORS.RED['300'],
            };
        default:
            return null;
    }
};
var getIconNotification = function (type) {
    switch (type) {
        case E_SNACKBAR_TYPE.VALID:
            return E_ICONS.CHECK;
        case E_SNACKBAR_TYPE.INFO:
            return E_ICONS.INFO;
        case E_SNACKBAR_TYPE.ERROR:
            return E_ICONS.WARNING;
        default:
            return null;
    }
};
var getNotificationSound = function (type) {
    switch (type) {
        case E_SNACKBAR_TYPE.ERROR:
            return '/audio/errorNotification.mp3';
        default:
            return '/audio/notification.mp3';
    }
};
export var NotificationSnackbar = function (props) {
    var type = props.type, description = props.description, withNotification = props.withNotification, _a = props.cancellable, cancellable = _a === void 0 ? false : _a, onEndOfDelay = props.onEndOfDelay;
    var _b = getColorsNotification(type), color = _b.color, backgroundColor = _b.backgroundColor, delayBar = _b.delayBar;
    var _c = useState(100), progressPercent = _c[0], setProgressPercent = _c[1];
    var _d = useState(false), itemHovered = _d[0], setItemHovered = _d[1];
    var basePath = window.env.BASE_PATH;
    useEffect(function () {
        if (!cancellable) {
            if (progressPercent > 0 && !itemHovered) {
                var interval_1 = setTimeout(function () {
                    var frameFrequency = 1000 / FRAME_BY_SECOND;
                    var pourcentToSub = (frameFrequency * 100) / NOTIFICATION_TIME_BEFORE_DISAPPEAR;
                    setProgressPercent(progressPercent - pourcentToSub);
                }, 1000 / FRAME_BY_SECOND);
                return function () { return clearTimeout(interval_1); };
            }
            else if (progressPercent <= 0) {
                onEndOfDelay();
            }
        }
    }, [cancellable, progressPercent, itemHovered]);
    var notificationSoundPath = getNotificationSound(type);
    return (_jsxs("div", __assign({ "data-test": IDENTIFIER_SNACKBAR_ITEM, className: 'snackbarNotification', style: { backgroundColor: backgroundColor }, onMouseOver: function () { return setItemHovered(true); }, onMouseLeave: function () { return setItemHovered(false); } }, { children: [withNotification && _jsx("audio", { autoPlay: true, src: basePath + notificationSoundPath }), !cancellable && (_jsx("div", __assign({ className: 'snackbarDelayBar', style: { backgroundColor: delayBar } }, { children: _jsx("span", { style: { width: "".concat(progressPercent, "%") } }) }))), _jsxs("div", __assign({ className: 'snackbarNotificationContent' }, { children: [_jsx(Icons, { icon: getIconNotification(type), color: color }), _jsx("p", __assign({ style: { color: color }, className: 'snackbarNotificationDescription' }, { children: description })), cancellable && _jsx(Icons, { icon: E_ICONS.CLOSE, onClick: onEndOfDelay, color: color, className: 'snackbarCloseIcon' })] }))] })));
};
export var SnackBar = function (props) {
    var notifications = props.notifications, removeNotification = props.removeNotification;
    return (_jsx("ul", __assign({ "data-test": IDENTIFIER_SNACKBAR_LIST, className: 'snackbarList' }, { children: notifications.map(function (notif, index) {
            return _jsx(NotificationSnackbar, __assign({}, notif, { onEndOfDelay: function () { return removeNotification(notif); } }), "".concat(notif.id));
        }) })));
};
